import React, { useState, useEffect, useRef } from "react";
import { message } from "antd";
import { useHistory } from "react-router-dom";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import PulseLoader from "react-spinners/PulseLoader";
import {
  order_creation_api,
  create_checkout_session_api,
  confirm_checkout_api,
  subscription_api,
  user_session_data_subpymt_api,
  user_session_data_custsetup_sp_api,
  custfeature_api,
  user_session_data_access_api,
  free_14_days_trial_api,
  user_session_data_subpymt_client_api,
  selection_proceedchange_api,
  custplan_new_subscription_api,
  paypal_prorated_amount_api,
  verify_paypal_payment_api
} from "../../../services/NewUI_API";
import "../../../App.css"
import { BASE_URL } from "../../../url/baseurl";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";

// const theme = localStorage.getItem('brandColor');
// const customer = localStorage.getItem('customerid');

export default function CheckoutForm() {
  
useEffect(() => {
      if(localStorage.getItem("brandColor") == null || localStorage.getItem("brandColor") == '' ){
        localStorage.setItem("brandColor","#ff8c24");  console.log("vasanth==>", );
    
      }
    }, []);
  const paypalRef = useRef(null);
  const checkoutConfirmStarted = useRef(false);
  const [payableAmount, setPayableAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [proratedData, setProratedData] = useState(null);
  const location = useLocation();
  let storedCheckoutPlan = null;
  try {
    storedCheckoutPlan = JSON.parse(sessionStorage.getItem("checkout_plan") || "null");
  } catch (e) {
    storedCheckoutPlan = null;
  }
  const { plan: locationPlan } = location.state || {};
  const plan = locationPlan || storedCheckoutPlan || {};
  const { payment_details } = location.state || {};
  const [specialData, setSpecialData] = useState({
    speccode: null,
    specprice: null,
    pymtid: null,
  });

  useEffect(() => {
    const st = location.state || {};
    const planState = st.plan || {};
    const storedSpeccode = localStorage.getItem("enroll_speccode");
    const storedSpecprice = localStorage.getItem("enroll_specprice");
    const storedPymtid = localStorage.getItem("enroll_pymtid");

    const resolve = (top, nested, stored) => {
      if (top != null && top !== "") return top;
      if (nested != null && nested !== "") return nested;
      if (stored != null && stored !== "") return stored;
      return null;
    };

    setSpecialData({
      speccode: resolve(st.speccode, planState.speccode, storedSpeccode),
      specprice: resolve(st.specprice, planState.specprice, storedSpecprice),
      pymtid: resolve(st.pymtid, planState.pymtid, storedPymtid),
    });
  }, [location]);

  const { speccode, specprice, pymtid } = specialData;

  const hasAppliedSpecialCode = Boolean(
    speccode || plan?.speccode || localStorage.getItem("enroll_speccode")
  );
  const summaryPlanName = hasAppliedSpecialCode
    ? plan?.pymtdesc ||
      localStorage.getItem("enroll_pymtdesc") ||
      plan?.name
    : plan?.name;
  const summaryUsers = hasAppliedSpecialCode
    ? plan?.userlimit ||
      localStorage.getItem("enroll_userlimit") ||
      plan?.users
    : plan?.users;
  const summaryPrice =
    specprice != null && specprice !== ""
      ? specprice
      : plan?.price;

  useEffect(() => {
    console.log("speccode:", speccode);
    console.log("specprice:", specprice);
    console.log("pymtid:", pymtid);
  }, [specialData]);

  useEffect(() => {
    console.log("speccode:", speccode);
    console.log("specprice:", specprice);
    console.log("pymtid:", pymtid);
  }, [speccode, specprice, pymtid]);

  console.log("payment_details", payment_details);
  const payment_type = payment_details?.payment_type;

  console.log("paymentType", payment_type);

  const isStripeLocked = payment_type === "paypal";
  const isPaypalLocked = payment_type === "stripe";

  console.log("isStripeLocked", isStripeLocked);

  const history = useHistory();

const [theme, setTheme] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [loader, setLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("stripe");
  const [planid, setPlanid] = useState(localStorage.getItem("Enroll_PlanID"));
  const stripe = useStripe();
  const elements = useElements();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const ModalStyle_Del = {
    content: {
      width: "500px",
      height: "200px !important",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      justifyContent: "center",
    },
  };


  useEffect(() => {
    if (localStorage.getItem("Renew_Plan") === "Yes") {
      setPlanid(localStorage.getItem("RenewPlanID"));
    }
    console.log("Enroll_PlanID", localStorage.getItem("Enroll_PlanID"));
    console.log("RenewPlanID", localStorage.getItem("Renew_Plan"));
setTheme(localStorage.getItem('brandColor'));
    setCustomer(localStorage.getItem('customerid'));
 
  }, []);
  const StyledButton1 = styled.button`
  background: ${theme} !important;
  width: 210px;
  border-radius: 30px;
  height: 50px;
  text-align: center;
  font-size: 20px !important;
  color: white;
  font-weight: 900;
  border-color: none;
  border: none;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 107, 0, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;
  useEffect(() => {
    if (payment_details?.payment_type === "paypal") {
      setActiveTab("paypal");
    } else if (payment_details?.payment_type === "stripe") {
      setActiveTab("stripe");
    }
  }, [payment_details?.payment_type]);

  let EnrData = JSON.parse(localStorage.getItem("EnrData"));
  console.log(EnrData);

  const getPlanDetails = () => {
    switch (planid) {
      case "2":
        return { name: "Limited Trial", price: "$0" };
      case "3":
        return { name: "Enterprise", price: "$840" };
      case "4":
        return { name: "60 Days Trial", price: "$0" };
      case "5":
        return { name: "Enterprise + Custom", price: "$1080" };
      case "6":
        return { name: "Consultants", price: "$1440" };
      default:
        return { name: "Unknown Plan", price: "$0" };
    }
  };

  const planDetails = getPlanDetails();

  const showBlockedDialog = (message) => {
    console.log("showBlockedDialog called with message:", message);
    setDialogMessage(message);
    setDialogOpen(true);
  };


  const handleTabChange = (key) => {

    console.log(key === "stripe" && isStripeLocked);
    if (key === "stripe" && isStripeLocked) {
      showBlockedDialog("This order must be paid using PayPal.");
      return;
    }

    if (key === "paypal" && isPaypalLocked) {
      showBlockedDialog("This order must be paid using Card.");
      return;
    }

    setActiveTab(key);
  };


  // Function to calculate total charge
  const calculateTotalCharge = () => {
    // You can modify this logic based on your actual pricing calculation
    const price = planDetails.price.replace('$', '');
    return `$${parseFloat(price).toFixed(2)}`;
  };

  function stripeTokenHandler(token) {
    console.log(token.id);
    setLoader(true);

    let price = 0;

    // Check if token has proper structure
    console.log("Token structure:", {
      type: token.type,
      id: token.id,
      amount: token.amount,
      subscription: token.subscription
    });

    if (localStorage.getItem("payment_type") == "paypal") {
      price = token.amount || plan.price;
    } else {
      price = plan.price;
    }
    if (localStorage.getItem("Renew_Plan") === "Yes") {
      order_creation_api({
        userid: localStorage.getItem("Renew_Plan_UserId"),
        // userid: localStorage.getItem("UserID"),
        stripe_token: token.id,
        price: localStorage.getItem("price_RP"),
        payment_type: localStorage.getItem("payment_type"),
      })
        .then((res) => {
          if (res.data.code == 200 && res.data.message == "Success") {
            console.log(res);
            const renewFlag = localStorage.getItem("renewFlag") || "no";
            subscription_api({
              userid: localStorage.getItem("Renew_Plan_UserId"),
              subscription: res.data.subscription,
              subscription_payal_id: token.subscription_id_paypal,
              customer: res.data.customer,
              price: price,
              plan_id: localStorage.getItem("RenewPlanID"),
              payment_type: localStorage.getItem("payment_type"),
              renew: renewFlag
            })
              .then((res1) => {
                if (res1.data.code == 200) {
                  console.log(res1);

                  custplan_new_subscription_api({
                    userid: localStorage.getItem("Renew_Plan_UserId"),
                  })
                    .then((res2) => {
                      console.log(res2);
                      if (res.data.code === 200) {
                        message.success("Successful");
                        history.push("/login");
                      }
                    })
                    .catch((err2) => {
                      console.log(err2);
                    });
                }
              })
              .catch((err1) => {
                console.log(err1);
              });
          } else if (res.data.code == 500) {
            message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          message.error(err.response.data.message);

        });
    } else {
      selection_proceedchange_api({
        Enrolling: EnrData.Enrolling,
        Newcust: EnrData.Newcust,
        Priorfree: EnrData.Priorfree,
        customerid: EnrData.customerid,
        selpymtid: EnrData.selpymtid,
        userid: localStorage.getItem("UserID") || localStorage.getItem("E_Userid"),
      })
        .then((resp) => {
          console.log(resp);
        })
        .catch((errr) => {
          console.log(errr);
        });

      // Common data
      const userid =
        localStorage.getItem("E_Userid") || localStorage.getItem("UserID");

      const paymentType = localStorage.getItem("payment_type");
      let payload = {};
      if (paymentType == "stripe") {
        payload = {
          userid: userid,
          stripe_token: token?.id,
          // price: localStorage.getItem("price_EP"),
          price: plan.price_id,
          payment_type: "stripe",
          speccode: specialData.speccode,
          specprice: specialData.specprice,
          pymtid: specialData.pymtid,
        };

      } else {
        payload = {
          userid: userid,
          payment_type: "paypal",
          subscription_id: localStorage.getItem("paypal_subscription_id"),
          order_id: localStorage.getItem("paypal_order_id"),
          payer_id: localStorage.getItem("paypal_payer_id"),
          email: localStorage.getItem("paypal_email"),
          first_name: localStorage.getItem("paypal_first_name"),
          plan_id: localStorage.getItem("Enroll_PlanID"),
          // price: localStorage.getItem("price_EP"),
          price: plan.price_id,
          start_date: localStorage.getItem("paypal_start_date"),
          end_date: localStorage.getItem("paypal_next_billing_date"),
          speccode:  specialData.speccode,
          specprice: specialData.specprice,  
          pymtid: specialData.pymtid,
        };
      }
      localStorage.getItem("Client_PlanID") == null
        ? ((localStorage.getItem("Enroll_PlanID") == 1)
          ? free_14_days_trial_api
          : order_creation_api)(
            payload
            // userid:
            //   localStorage.getItem("E_Userid") ||
            //   localStorage.getItem("UserID"),
            // stripe_token: token.id,
            // // price: localStorage.getItem("price_EP"),
            // price: plan.price,
            // payment_type: localStorage.getItem("payment_type"),
          )
          .then((res) => {
            if (res.data.code == 200) {
              console.log("Stripe Payment==>", res.data);
              message.success(res.data.message);
              const renewFlag = localStorage.getItem("renewFlag") || "no";
              subscription_api({
                userid:
                  localStorage.getItem("E_Userid") ||
                  localStorage.getItem("UserID"),
                subscription: res.data.subscription,
                subscription_payal_id: token.subscription_id_paypal,
                customer: res.data.customer,
                price: price,
                plan_id: localStorage.getItem("Enroll_PlanID"),
                payment_type: localStorage.getItem("payment_type"),
                renew: renewFlag
              })
                .then((res1) => {
                  if (res1.data.code == 200) {
                    console.log(res1);
                    localStorage.setItem("PlanID", res1.data.Data.plan_id)

                    user_session_data_subpymt_api(
                      localStorage.getItem("E_Userid") ||
                      localStorage.getItem("UserID")
                    )
                      .then((res2) => {
                        if (res2.data.code == 200) {
                          console.log(res2);

                          user_session_data_custsetup_sp_api({
                            sp_userid:
                              localStorage.getItem("E_Userid") ||
                              localStorage.getItem("UserID"),
                            ep_userid: null,
                            speccode: specialData.speccode || null,
                          })
                            .then((res3) => {
                              if (res3.data.code == 200) {
                                console.log(res3);

                                let data3 = {
                                  userid:
                                    localStorage.getItem("E_Userid") ||
                                    localStorage.getItem("UserID"),
                                };

                                custfeature_api(data3)
                                  .then((res4) => {
                                    console.log(res4);
                                    if (res4.data.code === 200) {
                                      console.log(
                                        "cust feature res4 data==>",
                                        res4.data
                                      );
                                      // message.success("Successfully3 !");

                                      user_session_data_access_api(
                                        localStorage.getItem("E_Userid") ||
                                        localStorage.getItem("UserID")
                                      )
                                        .then((res5) => {
                                          console.log(res5);
                                          if (res5.data.code === 200) {
                                            setLoader(false);
                                            console.log(
                                              "user session res5 data==>",
                                              res5.data
                                            );
                                            res3.data.message ==
                                              "Begin_program"
                                              ?
                                              (window.location.href =
                                                "/extquestion2")
                                              : (window.location.href =
                                                "/login");
                                          } else {
                                            console.log(res5.data.message);
                                          }
                                        })
                                        .catch((err5) => {
                                          setLoader(false);
                                          console.log("error usd--->>", err5);
                                        });
                                    } else {
                                      // message.error(res3.data.message);
                                      console.log(res3.data.message);
                                    }
                                  })
                                  .catch((err4) => {
                                    setLoader(false);
                                    console.log("error cf--->>", err4);
                                  });
                              } else {
                                message.error("Something went wrong");

                              }
                            })
                            .catch((err3) => {
                              setLoader(false);
                              console.log(err3);
                            });
                        } else {
                          // message.error("Something went wrong");
                          window.location.href =
                            "/login"
                        }
                      })
                      .catch((err2) => {
                        setLoader(false);
                        console.log(err2);
                      });
                  } else {
                    //  message.error("Something went wrong");
                    window.location.href =
                      "/login"
                  }
                })
                .catch((err1) => {
                  setLoader(false);
                  console.log(err1);
                });
            } else if (res.data.code == 500) {
              message.error(res.data.message);
            }
            else {
              message.error("Something went wrong");
              // history.push("/topics_program")
            }
          })
          .catch((err) => {
            setLoader(false);
            console.log("error payment===>", err);
            message.error(err.response.data.message);
          })
        : order_creation_api(
          payload
          // // userid: 100000050,
          // userid: localStorage.getItem("UserID"),
          // stripe_token: token.id,
          // // price: localStorage.getItem("price_SP"),
          // price: plan.price,
          // payment_type: localStorage.getItem("payment_type"),
        )
          .then((res) => {
            if (res.data.code == 200 && res.data.message == "Success") {
              console.log("Stripe Payment==>>>>", res.data);
              message.success(res.data.message);
              const renewFlag = localStorage.getItem("renewFlag") || "no";
              subscription_api({
                userid: localStorage.getItem("UserID"),
                subscription: res.data.subscription,
                customer: res.data.customer,
                price: price,
                plan_id: localStorage.getItem("Client_PlanID"),
                payment_type: localStorage.getItem("payment_type"),
                renew: renewFlag
              })
                .then((res1) => {
                  if (res1.data.code == 200) {
                    console.log(res1);

                    user_session_data_subpymt_client_api(
                      localStorage.getItem("UserID")
                    )
                      .then((res2) => {
                        if (res2.data.code == 200) {
                          console.log(res2);

                          if (res2.data.message == "custsetup") {
                            user_session_data_custsetup_sp_api({
                              sp_userid: localStorage.getItem("UserID"),
                              ep_userid: null,
                              speccode: specialData.speccode || null,
                            })
                              .then((res3) => {
                                if (res3.data.code == 200) {
                                  console.log(res3);

                                  let data3 = {
                                    userid: localStorage.getItem("UserID"),
                                  };

                                  custfeature_api(data3)
                                    .then((res4) => {
                                      console.log(res4);
                                      if (res4.data.code === 200) {
                                        console.log(
                                          "cust feature res4 data==>",
                                          res4.data
                                        );
                                        // message.success("Successfully3 !");

                                        user_session_data_access_api(
                                          localStorage.getItem("UserID")
                                        )
                                          .then((res5) => {
                                            console.log(res5);
                                            if (res5.data.code === 200) {
                                              setLoader(false);
                                              console.log(
                                                "user session res5 data==>",
                                                res5.data
                                              );
                                              // message.success("Successfully4 !");
                                              history.push("/extquestion2");
                                            } else {
                                              // message.error(res5.data.message);
                                              console.log(res5.data.message);
                                            }
                                          })
                                          .catch((err5) => {
                                            setLoader(false);
                                            console.log(
                                              "error usd--->>",
                                              err5
                                            );
                                          });
                                      } else {
                                        // message.error(res3.data.message);
                                        console.log(res3.data.message);
                                      }
                                    })
                                    .catch((err4) => {
                                      setLoader(false);
                                      console.log("error cf--->>", err4);
                                    });
                                } else {
                                  message.error("Something went wrong");
                                }
                              })
                              .catch((err3) => {
                                setLoader(false);
                                console.log(err3);
                              });
                          } else {
                            history.push(
                              `/clientfunction/en/enrollclient/${localStorage.getItem(
                                "CrID"
                              )}`
                            );
                          }
                        } else {
                          message.error("Something went wrong");
                        }
                      })
                      .catch((err2) => {
                        setLoader(false);
                        console.log(err2);
                      });
                  } else {
                    message.error("Something went wrong");
                  }
                })
                .catch((err1) => {
                  setLoader(false);
                  console.log(err1);
                });
            } else if (res.data.code == 500) {
              message.error(res.data.message);
            }
            else {
              message.error("Something went wrong");
              // history.push("/topics_program")
            }
          })
          .catch((err) => {
            setLoader(false);
            console.log("error payment===>", err);
            message.error(err.response.data.message);
          });
    }
  }


  const handleSubmit = async () => {

    console.log("loader ==>", loader);
    if (loader == false) {
      setLoader(true);
      console.log("userid", localStorage.getItem("Renew_Plan_UserId"));
      console.log("price", localStorage.getItem("price_EP"));

      console.log("price", localStorage.getItem("Renew_Plan"));

      if (!stripe || !elements) {

        return;
      }

      const card = elements.getElement(CardElement);

      // const numbercard = elements.getElement(CardNumberElement); 
      // const expirycard = elements.getElement(CardExpiryElement); 
      // const cvvcard = elements.getElement(CardCvcElement); 
      // const CardElement = elements.getElement(CardElement); 

      console.log("CardElement ==>", card);
      // console.log("expirycard ==>",expirycard);
      // console.log("cvvcard ==>",cvvcard);

      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: card,
      });

      if (error) {
        message.error(error.message);
      } else {
        // Payment method created successfully, submit the form
        // to your server for further processing
        console.log("payment ==>", paymentMethod);
      }
      const result = await stripe.createToken(card);



      // const result = await stripe.createToken(numbercard,expirycard,cvvcard);

      if (result.error) {
        // Show error to your customer.
        console.log(result.error.message);
        setLoader(false);
      } else {
        // Send the token to your server.
        // This function does not exist yet; we will define it in the next step.
        localStorage.setItem("payment_type", "stripe");
        stripeTokenHandler(result.token);
        console.log(result.token);
      }
    }
  };


  const handlePayPalSubmit = () => {

  };

  useEffect(() => {

     if (
        !plan?.id
      ) {
        return;
      }
    const calculateProratedAmount = async () => {
      try {
        let plan_id = "";
        let amount = 0;

        // if (plan.id == 2) {
        //   plan_id = 2;
        //   amount = 660; // Plan 2 price
        // } else if (plan.id == 3) {
        //   plan_id = 3;
        //   amount = 1800; // Plan 3 price
        // }

        if (specialData.specprice != null && parseFloat(specialData.specprice) >= 0) {
          amount = parseFloat(specialData.specprice);
        } else if (plan.id == 2) {
          plan_id = 2;
          amount = 660;
        } else if (plan.id == 3) {
          plan_id = 3;
          amount = 1800;
        }
        
        // Call backend to get prorated amount
        const res = await paypal_prorated_amount_api({
          userid: localStorage.getItem("UserID"),
          price: amount,
          speccode:  specialData.speccode || null,
        });

        console.log("Prorated calculation result:", res);

        if (res.code === 200) {
          let renewFlag = false;

          if (res.message == "Previous subscription expired") {
            renewFlag = true;
          }

          const finalAmount = res.final_amount !== null ? res.final_amount : amount;
          const fullAmount = res.full_amount !== null ? res.full_amount : amount;

          setPayableAmount(finalAmount);
          setProratedData({
            full_amount: fullAmount,
            prorated_amount: res.prorated_amount || 0,
            days_remaining: res.days_remaining,
            days_used: res.days_used
          });
          if (renewFlag) {
            localStorage.setItem("renewFlag", "yes");
          } else {
            localStorage.setItem("renewFlag", "no");
          }
        } else {
          // Fallback to full amount if calculation fails
          setPayableAmount(amount);
          setProratedData({
            full_amount: amount,
            prorated_amount: 0,
            days_remaining: 0,
            days_used: 0
          });
          localStorage.setItem("renewFlag", "no");
        }

        setIsLoading(false);
      } catch (error) {
        console.error("Error calculating prorated amount:", error);
        localStorage.setItem("renewFlag", "no");
        // Fallback to full plan price
        let amount = 0;
        if (plan.id == 2) amount = 660;
        else if (plan.id == 3) amount = 1800;
        setPayableAmount(amount);
        setProratedData({
          full_amount: amount,
          prorated_amount: 0,
          days_remaining: 0,
          days_used: 0
        });
        setIsLoading(false);
      }
    };

    calculateProratedAmount();
  }, [plan.id,
      specialData.speccode,
      specialData.specprice,
      specialData.pymtid
  ]);

  useEffect(() => {
    if (!isLoading && payableAmount > 0) {
      return undefined;
    }
    if (!isLoading && payableAmount > 0) {
      localStorage.setItem("Enroll_PlanID", planid);

      if (paypalRef.current && paypalRef.current.children.length > 0) {
        paypalRef.current.innerHTML = '';
      }

      const script = document.createElement("script");
      //paypal sandbox
      //script.src = "https://www.sandbox.paypal.com/sdk/js?client-id=AaeIZWndVeusbANmKL6J23YVkCJwBj-M5rbNVySpoGdh8L2XLatuImGEWM6UkKYrBEWvyDzXNhXiaduN&intent=capture&disable-funding=card,credit,paylater&currency=USD";
     //paypal live
     script.src = "https://www.paypal.com/sdk/js?client-id=ASMvK2AgygozS4U8CoTAcbVfWuqYW3dTAhM7ttMu8ZMI8F7lDDveU9LmJuzcmH2d1mQw5LbOx5PZpXmU&intent=capture&disable-funding=card,credit,paylater&currency=USD";

     
     script.async = true;

      script.onload = () => {
        if (!window.paypal) {
          console.error("PayPal SDK not loaded");
          return;
        }

        window.paypal
          .Buttons({
            fundingSource: window.paypal.FUNDING.PAYPAL,
            style: {
              shape: "rect",
              color: "gold",
              layout: "vertical",
              label: "pay",
            },

            createOrder: (data, actions) => {
              // const finalAmount = (specprice != null && specprice >= 0)
              //   ? parseFloat(specprice)
              //   : payableAmount;
              let finalAmount = payableAmount;

              if (specprice != null) {
                  finalAmount = parseFloat(specprice) <= 0
                      ? 0.01
                      : parseFloat(specprice);
              }
              console.log("PayPal amount used:", finalAmount, specprice ? "(special price)" : "(regular)");
              return actions.order.create({
                intent: "CAPTURE",
                application_context: {
                  user_action: "PAY_NOW"
                },
                purchase_units: [
                  {
                    amount: {
                      currency_code: "USD",
                      value: finalAmount.toFixed(2), 
                    // value: "1.00",

                    },
                    description: `${summaryPlanName || plan.name} Plan - 1 Year Subscription`,
                  },
                ],
              });
            },


            onApprove: async (data, actions) => {
              try {
                console.log("✅ PayPal onApprove triggered");
                const details = await actions.order.capture();
                console.log("✅ PayPal Capture Details:", details);

                localStorage.setItem("payment_type", "paypal");
                localStorage.setItem("paypal_order_id", details.id);
                localStorage.setItem("paypal_payer_id", details.payer.payer_id);
                localStorage.setItem("paypal_email", details.payer.email_address);
                localStorage.setItem("paypal_first_name", details.payer.name.given_name);
                localStorage.setItem("paypal_amount", payableAmount);

                // Store dates for one-year subscription
                const startDate = new Date();
                const endDate = new Date();
                endDate.setFullYear(endDate.getFullYear() + 1);

                localStorage.setItem("paypal_start_date", startDate.toISOString());
                localStorage.setItem("paypal_next_billing_date", endDate.toISOString());

                try {
                  const verificationResponse = await verify_paypal_payment_api({
                    order_id: details.id
                  });

                  console.log("✅ PayPal Verification Response:", verificationResponse);

                  if (verificationResponse.code !== 200) {
                    throw new Error("Payment verification failed: " + verificationResponse.message);
                  }

                  console.log("✅ Payment verified successfully!");

                } catch (verificationError) {
                  console.error("❌ Payment verification error:", verificationError);
                  alert("Payment verification failed. Please contact support.");
                  return;
                }

               
                const currentTime = Math.floor(Date.now() / 1000);
                const oneYearLater = currentTime + 31536000; 

                const paypalToken = {
                  id: details.id, 
                  type: "paypal",
                  plan_id: plan.id,
                  payerID: details.payer.payer_id,
                  amount: payableAmount,
                  currency: "USD",
                  prorated_data: proratedData,   
                  subscription_id_paypal: details.id,
                  customer: {
                    email: details.payer.email_address,
                    name: details.payer.name.given_name + ' ' + (details.payer.name.surname || '')
                  },
               
                  subscription: {
                    id: details.id,
                    status: 'active',
                    current_period_start: currentTime,
                    current_period_end: oneYearLater,
                    plan: {
                      id: 'paypal_plan_' + plan.id,
                      amount: payableAmount * 100,
                      currency: 'USD',
                      interval: 'year',
                      interval_count: 1,
                      product: 'paypal_product_' + plan.id,
                      trial_period_days: 0
                    },
                    latest_invoice: 'inv_paypal_' + details.id,
                    customer: details.payer.email_address,
                    trial_start: null,
                    trial_end: null
                  }
                };

                console.log("✅ PayPal token with extra parameter:", {
                  subscription_id_paypal: paypalToken.subscription_id_paypal,
                  subscription_id: paypalToken.subscription.id
                });
                stripeTokenHandler(paypalToken);

              } catch (error) {
                console.error("❌ Error processing PayPal payment:", error);
                message.error("Payment processing failed: " + error.message);
              }
            },
            onError: (err) => {
              console.error("PayPal Error", err);
              alert("An error occurred with PayPal. Please try again.");
            },

            onCancel: (data) => {
              console.log("Payment cancelled by user", data);
            }
          })
          .render(paypalRef.current);
      };

      script.onerror = () => {
        console.error("Failed to load PayPal SDK");
        setIsLoading(false);
      };

      document.body.appendChild(script);

      return () => {
        if (script.parentNode) {
          document.body.removeChild(script);
        }
      };
    }
  }, [isLoading, payableAmount, plan.id, proratedData]);

  const finishCheckoutEnrollment = (confirmRes) => {
    const userid = localStorage.getItem("E_Userid") || localStorage.getItem("UserID");
    const speccodeValue = localStorage.getItem("enroll_speccode") || null;
    const isClientEnroll = localStorage.getItem("Client_PlanID") != null;
    if (!isClientEnroll) {
      localStorage.removeItem("customerid");
    }

    if (confirmRes?.data?.Data?.plan_id) {
      localStorage.setItem("PlanID", confirmRes.data.Data.plan_id);
    }
    localStorage.setItem("payment_type", "stripe");
    message.success(confirmRes?.data?.message || "Success");

    const continueSetup = () => {
      user_session_data_custsetup_sp_api({
        sp_userid: userid,
        ep_userid: null,
        speccode: speccodeValue,
      })
        .then((res3) => {
          if (res3.data.code != 200) {
            setLoader(false);
            message.error("Something went wrong");
            return;
          }

          custfeature_api({ userid })
            .then((res4) => {
              if (res4.data.code !== 200) {
                setLoader(false);
                return;
              }

              user_session_data_access_api(userid)
                .then((res5) => {
                  setLoader(false);
                  if (res5.data.code !== 200) {
                    return;
                  }
                  if (!isClientEnroll && res3.data.message == "Begin_program") {
                    window.location.href = "/extquestion2";
                  } else if (!isClientEnroll) {
                    window.location.href = "/login";
                  } else {
                    history.push("/extquestion2");
                  }
                })
                .catch(() => setLoader(false));
            })
            .catch(() => setLoader(false));
        })
        .catch(() => setLoader(false));
    };

    const subpymt = isClientEnroll
      ? user_session_data_subpymt_client_api(userid)
      : user_session_data_subpymt_api(userid);

    subpymt
      .then((res2) => {
        if (res2.data.code != 200) {
          setLoader(false);
          if (!isClientEnroll) {
            window.location.href = "/login";
          } else {
            message.error("Something went wrong");
          }
          return;
        }

        if (isClientEnroll && res2.data.message != "custsetup") {
          setLoader(false);
          history.push(
            `/clientfunction/en/enrollclient/${localStorage.getItem("CrID")}`
          );
          return;
        }

        continueSetup();
      })
      .catch(() => {
        setLoader(false);
        message.error("Unable to finish enrollment");
      });
  };

  const handleProceedToPay = () => {
    const userid = localStorage.getItem("E_Userid") || localStorage.getItem("UserID");
    const planId = plan?.id || localStorage.getItem("Enroll_PlanID");

    if (!userid) {
      message.error("Please sign in again before paying.");
      return;
    }

    if (String(planId) !== "2" && String(planId) !== "3") {
      message.error("Select Small Business or Multi-Site before paying.");
      return;
    }

    setLoader(true);
    sessionStorage.setItem("checkout_plan", JSON.stringify({
      id: plan.id,
      name: plan.name,
      location: plan.location,
      users: plan.users,
      price: plan.price,
      pymtdesc: plan.pymtdesc || null,
      userlimit: plan.userlimit || null,
      isSpecialPrice: !!plan.isSpecialPrice,
      speccode: plan.speccode || null,
      specprice: plan.specprice || null,
      pymtid: plan.pymtid || null,
    }));
    create_checkout_session_api({
      userid,
      plan_id: planId,
      speccode: speccode || localStorage.getItem("enroll_speccode") || null,
      return_origin: window.location.origin,
    })
      .then((res) => {
        if (res.data.code === 200 && res.data.url) {
          window.location.href = res.data.url;
          return;
        }
        setLoader(false);
        message.error(res.data.message || "Unable to start payment");
      })
      .catch((err) => {
        setLoader(false);
        message.error(err.message || "Unable to start payment");
      });
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const checkout = params.get("checkout");
    const sessionId = params.get("session_id");

    if (checkout === "cancel") {
      message.info("Payment was cancelled. You can proceed to pay again.");
      window.history.replaceState({}, "", "/payment");
      return;
    }

    if (checkout !== "success" || !sessionId || checkoutConfirmStarted.current) {
      return;
    }

    checkoutConfirmStarted.current = true;
    const userid = localStorage.getItem("E_Userid") || localStorage.getItem("UserID");
    setLoader(true);
    confirm_checkout_api({
      session_id: sessionId,
      userid,
    })
      .then((res) => {
        if (res.data.code === 200) {
          window.history.replaceState({}, "", "/payment");
          finishCheckoutEnrollment(res);
          return;
        }
        checkoutConfirmStarted.current = false;
        setLoader(false);
        message.error(res.data.message || "Payment could not be confirmed");
      })
      .catch((err) => {
        checkoutConfirmStarted.current = false;
        setLoader(false);
        message.error(err.message || "Payment could not be confirmed");
      });
  }, []);


  return (
    <>
      {customer == null || !customer ? (
   
        <div className="container justify-content-center align-items-center payment">
          <div className="justify-content-around" align="center" style={{ marginTop: "5%" }}>
            <StyledButton1
              onClick={() => {
                history.push("/enroll_ui")
              }}
            >
              Back
            </StyledButton1>
          </div>


          <div style={{ gap: '30px', marginTop: "8%" }} className="row justify-content-center align-items-center w-100">
            {/* Order Summary */}
            <div style={{
              flex: 0.6,
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              padding: "25px",
              borderRadius: "8px",
              height: 'fit-content'
            }} className="mt-4 justify-content-center">
              <h3 style={{ color: theme, textAlign: "center", marginBottom: '20px' }}>Order Summary</h3>
              <hr style={{ margin: "0 0 25px 0" }} />
              <div style={{ marginBottom: '15px' }}>
                <strong>Plan:</strong> {summaryPlanName}
              </div>
              <div style={{ marginBottom: '15px' }}>
                <strong>Price:</strong> ${summaryPrice} per year ({summaryUsers} users)
              </div>
              <hr style={{ margin: "20px 0" }} />
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', textAlign: 'center' }}>
                Total Charge: ${summaryPrice}
              </div>
              <div className="text-center mt-4">
                <button
                  type="button"
                  className="mobileButton"
                  style={{
                    background: theme,
                    color: "white",
                    minWidth: "180px",
                    height: "40px",
                    borderRadius: "5px",
                    fontSize: "17px",
                    border: "none",
                    padding: "0 16px",
                  }}
                  onClick={handleProceedToPay}
                  disabled={loader}
                >
                  {loader ? (
                    <PulseLoader size={10} color={"#fff"} />
                  ) : (
                    "Proceed to Pay"
                  )}
                </button>
              </div>
            </div>
          </div>

          <Dialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>Payment Method Restricted</DialogTitle>

            <DialogContent>
              <p style={{ margin: 0 }}>{dialogMessage}</p>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => setDialogOpen(false)}
                variant="contained"
                style={{ background: theme }}
              >
                OK
              </Button>
            </DialogActions>
          </Dialog>

        </div>
      ) : (


        <div className="container justify-content-center align-items-center payment">
          <div className="justify-content-around" align="center" style={{ marginTop: "5%" }}>
            <StyledButton1
              onClick={() => {
                history.push("/enroll_ui")
              }}
            >
              Back
            </StyledButton1>
          </div>


          <div style={{ gap: '30px', marginTop: "8%" }} className="row justify-content-center align-items-center w-100">
            {/* Order Summary */}
            <div style={{
              flex: 0.6,
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              padding: "25px",
              borderRadius: "8px",
              height: 'fit-content'
            }} className="mt-4 justify-content-center">
              <h3 style={{ color: theme, textAlign: "center", marginBottom: '20px' }}>Order Summary</h3>
              <hr style={{ margin: "0 0 25px 0" }} />
              <div style={{ marginBottom: '15px' }}>
                <strong>Plan:</strong> {summaryPlanName}
              </div>
              <div style={{ marginBottom: '15px' }}>
                <strong>Price:</strong> ${summaryPrice} per year ({summaryUsers} users)
              </div>
              <hr style={{ margin: "20px 0" }} />
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', textAlign: 'center' }}>
                Total Charge: ${summaryPrice}
              </div>
              <div className="text-center mt-4">
                <button
                  type="button"
                  className="mobileButton"
                  style={{
                    background: theme,
                    color: "white",
                    minWidth: "180px",
                    height: "40px",
                    borderRadius: "5px",
                    fontSize: "17px",
                    border: "none",
                    padding: "0 16px",
                  }}
                  onClick={handleProceedToPay}
                  disabled={loader}
                >
                  {loader ? (
                    <PulseLoader size={10} color={"#fff"} />
                  ) : (
                    "Proceed to Pay"
                  )}
                </button>
              </div>
            </div>
          </div>

          <Dialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>Payment Method Restricted</DialogTitle>

            <DialogContent>
              <p style={{ margin: 0 }}>{dialogMessage}</p>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => setDialogOpen(false)}
                variant="contained"
                style={{ background: theme }}
              >
                OK
              </Button>
            </DialogActions>
          </Dialog>

        </div>
      )}
    </>
  );
}